const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M9.99984 11.6667V14.1667M6.6665 8.33333V5.83333C6.6665 3.99238 8.15889 2.5 9.99984 2.5C11.553 2.5 12.8581 3.56231 13.2282 5M5.83317 17.5H14.1665C15.087 17.5 15.8332 16.7538 15.8332 15.8333V10C15.8332 9.07953 15.087 8.33333 14.1665 8.33333H5.83317C4.9127 8.33333 4.1665 9.07953 4.1665 10V15.8333C4.1665 16.7538 4.9127 17.5 5.83317 17.5Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
